import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import {
  formatManagerDocumentDeadline,
  formatManagerDocumentPeriod,
} from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/utils/reviewUtils.ts';
import { managerStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/styles.ts';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';
import type { TApiSupervisorApplicationDocument } from '~/modules/covenants/types.ts';
import { tableRowStyles } from '~/modules/covenants/utils.ts';

interface IManagerDocumentGroupRowProps {
  document: TApiSupervisorApplicationDocument;
  hasFiles: boolean;
}

export const DocumentGroupRow: React.FC<IManagerDocumentGroupRowProps> = ({
  document,
  hasFiles,
}) => (
  <TableRow
    hover
    sx={(theme) => ({
      ...tableRowStyles(managerStyles.tableRow, theme),
      ...tableRowStyles(managerComponentStyles.docsGroupRow, theme),
    })}
  >
    <TableCell sx={managerComponentStyles.docsBodyCell}>
      <Typography variant="body2" fontWeight={600} sx={managerComponentStyles.docsGroupName}>
        {document.documentName || ''}
      </Typography>
      {!hasFiles && (
        <Typography variant="caption" color="text.secondary">
          Файли відсутні
        </Typography>
      )}
    </TableCell>
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell}>
      <Typography variant="body2" sx={managerComponentStyles.docsTermValue}>
        {formatManagerDocumentDeadline(document.deadline)}
      </Typography>
    </TableCell>
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell} />
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell} />
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell} />
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell}>
      <Typography variant="body2" sx={managerComponentStyles.docsTermValue}>
        {formatManagerDocumentPeriod(document)}
      </Typography>
    </TableCell>
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell} />
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell} />
    <TableCell align="center" sx={managerComponentStyles.docsBodyCell} />
  </TableRow>
);


